/* __next_internal_client_entry_do_not_use__ RenderDiscoverPageRoute auto */ import { renderDiscoverPageRoute } from "@faire/retailer-visitor-shared/views/discover/Route";
export var RenderDiscoverPageRoute = function() {
    return renderDiscoverPageRoute();
};
